import Vue from 'vue'
import Vuex from 'vuex'
import protal from "@/api/protal";

Vue.use(Vuex)
Vue.prototype.$store = store

const store = new Vuex.Store({
	state: {
		navbar: [{
			name: '首页',
			icon: require('@/assets/images/week_111.png'),
			activeicon: require('@/assets/images/index_21.png'),
			exact: true,
			link: '/',
			child: []
		}, {
			name: '真题练习',
			icon: require('@/assets/images/index_765.png'),
			activeicon: require('@/assets/images/ztactive.png'),
			exact: false,
			link: '/writing_practice',
			show: false,
			child: [{
				name: '全部',
				link: '/writing_practice?type=-1&g=1'
			}, {
				name: '口语',
				link: '/writing_practice?type=0&g=1'
			}, {
				name: '写作',
				link: '/writing_practice?type=1&g=1'
			}, {
				name: '阅读',
				link: '/writing_practice?type=2&g=1'
			}, {
				name: '听力',
				link: '/writing_practice?type=3&g=1'
			}]
		}, {
			name: '本周高频',
			icon: require('@/assets/images/index_32.png'),
			activeicon: require('@/assets/images/bzactive_03.png'),
			exact: false,
			link: '/week',
			child: []
		}, {
			name: '今日练习',
			icon: require('@/assets/images/index_32.png'),
			activeicon: require('@/assets/images/bzactive_03.png'),
			exact: false,
			link: '/today',
			child: []
		}, {
			name: '整套模考',
			icon: require('@/assets/images/index_766.png'),
			activeicon: require('@/assets/images/ztactive_03.png'),
			exact: false,
			link: '/package_test',
			child: []
		}, {
			name: '真题单词',
			icon: require('@/assets/images/index_763.png'),
			activeicon: require('@/assets/images/ztsactive_03.png'),
			exact: false,
			link: '/Writing_word',
			child: []
		}, {
			name: '视频课堂',
			icon: require('@/assets/images/index_764.png'),
			activeicon: require('@/assets/images/spactive_03.png'),
			exact: false,
			link: '/video',
			child: []
		}, {
			name: '作业练习',
			icon: require('@/assets/images/index_58.png'),
			activeicon: require('@/assets/images/zyactive_03.png'),
			exact: false,
			link: '/homework',
			child: []
		}, {
			name: '云课堂',
			icon: require('@/assets/images/index_60.png'),
			activeicon: require('@/assets/images/index_60.png'),
			exact: false,
			link: '/s',
			child: []
		},  {
			name: '社区',
			icon: require('@/assets/images/index_32.png'),
			activeicon: require('@/assets/images/bzactive_03.png'),
			exact: false,
			link: '/week',
			child: []
		}, {
			name: '联系我们',
			icon: require('@/assets/images/index_65.png'),
			activeicon: require('@/assets/images/index_65.png'),
			exact: false,
			link: '/s',
			child: []
		}, {
			name: '个人中心',
			icon: require('@/assets/images/index_73.png'),
			activeicon: require('@/assets/images/gractive_03.png'),
			exact: false,
			link: '/userinfo',
			show: false,
			child: [{
				name: '个人资料',
				link: '/userinfo'
			}, {
				name: '我的收藏',
				link: '/userinfo_collect'
			}, {
				name: '学习计划',
				link: '/userinfo_studyPlan'
			}, {
				name: '我的笔记',
				link: '/my_note'
			}, {
				name: '考试回忆',
				link: '/memory'
			}]
		}],
		lang: localStorage.getItem("lang") || 'ch',
		baseSrc: '/static/images/',
		loginShow: false,
		loginFlag: false,
		userInfo: {},
		autoPlay: true,
		showWordInfo: false,
		showScroe: false,
		aiAsqShow: false,
		airarsdlrlShow: false,
		airarsdlrlShow1: false,
		aiSwtShow: false,
		aiWeShow: false,
		showaiWfdShow: false,
		aiDescShow: false,
		showNavs: true,
		vipShow: false,
	},
	mutations: {
		changeLanguage(state, lang) {
			state.lang = lang;
		},
		showVip(state, status) {
			state.vipShow = status;
		},
		showNavsBtn(state, status) {
			state.showNavs = status;
		},
		showaiDESCShow(state, status) {
			state.aiDescShow = status;
		},
		showaiWfdShow(state, status) {
			state.showaiWfdShow = status;
		},
		showaiWeShow(state, status) {
			state.aiWeShow = status;
		},
		showaiSwtShow(state, status) {
			state.aiSwtShow = status;
		},
		showairarsdlrlShow(state, status) {
			state.airarsdlrlShow = status;
		},
		showairarsdlrlShow1(state, status) {
			state.airarsdlrlShow1 = status;
		},
		showaiAsqShow(state, status) {
			state.aiAsqShow = status;
		},
		showScroeInfo(state, status) {
			state.showScroe = status;
		},
		showTeacherFeedbackInfo(state, status) {
			state.showTeacherFeedback = status;
		},
		showWordInfo(state, status) {
			state.showWordInfo = status;
		},
		autoPlayChange(state, status) {
			state.autoPlay = status;
		},
		changeLogin(state, status) {
			state.loginShow = status;
		},
		changeLoginFlag(state, status) {
			state.loginFlag = status;
		},
		getUserinfo() {
			if(localStorage.getItem('token')) {
				this.state.userInfo = JSON.parse(localStorage.getItem("userinfo"))
				// 修复VIP状态判断逻辑
				if(this.state.userInfo.isVip == 1) {
					console.log('用户是VIP:', this.state.userInfo);
					this.state.vipShow = false  // VIP用户不显示开通VIP按钮
				} else {
					console.log('用户不是VIP:', this.state.userInfo);
					this.state.vipShow = true   // 非VIP用户显示开通VIP按钮
				}
			}
		},
		navbarShow(state, v) {
			state.navbar[v].show = true
		},
		navbarHide(state, v) {
			state.navbar[v].show = false
		},
	}
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js